/* unplugin-vue-components disabled */import { render } from "./ExamBlock.vue?vue&type=template&id=01a00117&scoped=true"
import script from "./ExamBlock.vue?vue&type=script&lang=js"
export * from "./ExamBlock.vue?vue&type=script&lang=js"

import "./ExamBlock.vue?vue&type=style&index=0&id=01a00117&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a00117"]])

export default __exports__